export const FETCH_TV_SHOWS = 'FETCH_TV_SHOWS'
export const FETCH_TV_SHOWS_DETAILS = 'FETCH_TV_SHOWS_DETAILS'
export const SEARCHED_TV_SHOWS ='SEARCHED_TV_SHOWS'
export const TOGGEL_MENU ='TOGGEL_MENU'
export const SET_TABS ='SET_TABS'